/**
 * Gemeinsame Anzeige-Bausteine für E-Mail-Vorlagen (Vorlagenliste und Composer-Auswahl):
 * - VorlagenPillen: Projekt-Zuordnung, Leadphase, „Geeignet für“ als Pillen
 * - FavoritStern: Favoritenstern je Benutzer (Favoriten stehen stets oben)
 * - favoritenZuerst: stabile Sortierung „Favoriten zuerst“, sonst bisherige Reihenfolge
 */
import { FolderKanban, Target, Star } from 'lucide-react';
import { produktlinieLabel } from '../../utils/produktlinien';

export const favoritenZuerst = (liste = []) => [
  ...liste.filter((t) => t.is_favorite),
  ...liste.filter((t) => !t.is_favorite),
];

export function FavoritStern({ aktiv, onToggle, testId, className = '' }) {
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); onToggle?.(); }}
      onMouseDown={(e) => e.stopPropagation()}
      draggable={false}
      className={`shrink-0 p-1 rounded hover:bg-amber-50 ${className}`}
      title={aktiv ? 'Favorit entfernen' : 'Als Favorit markieren (steht dann oben)'}
      aria-label={aktiv ? 'Favorit entfernen' : 'Als Favorit markieren'}
      aria-pressed={!!aktiv}
      data-testid={testId}
    >
      <Star className={`w-4 h-4 ${aktiv ? 'fill-amber-400 text-amber-500' : 'text-gray-300 hover:text-amber-400'}`} />
    </button>
  );
}

export default function VorlagenPillen({ template, projects = [], leadPhases = [], className = 'mt-1' }) {
  const projektIds = [...new Set([...(template.project_ids || []), ...(template.project_id ? [template.project_id] : [])])];
  const projektName = (id) => {
    const p = projects.find((x) => (x.id || x._id) === id);
    return p ? (p.name || p.title || `Projekt ${p.project_number || ''}`.trim()) : null;
  };
  const projekte = projektIds.map(projektName).filter(Boolean);
  const phase = template.lead_phase_key
    ? (leadPhases.find((x) => x.id === template.lead_phase_key)?.label || template.lead_phase_key)
    : null;
  const geeignet = (template.geeignet_fuer || []).map(produktlinieLabel);
  if (!projekte.length && !phase && !geeignet.length) return null;
  const pille = 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium border max-w-[220px] truncate';
  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`} data-testid={`template-pillen-${template.id || template._id}`}>
      {projekte.map((name) => (
        <span key={`p-${name}`} className={`${pille} bg-violet-50 text-violet-700 border-violet-200`} title={`Projekt: ${name}`}>
          <FolderKanban className="w-3 h-3 shrink-0" />{name}
        </span>
      ))}
      {phase && (
        <span className={`${pille} bg-sky-50 text-sky-700 border-sky-200`} title={`Leadphase: ${phase}`}>
          <Target className="w-3 h-3 shrink-0" />{phase}
        </span>
      )}
      {geeignet.map((g) => (
        <span key={`g-${g}`} className={`${pille} bg-slate-50 text-slate-700 border-slate-200`} title={`Geeignet für: ${g}`}>
          {g}
        </span>
      ))}
    </div>
  );
}
